import { render, staticRenderFns } from "./communityRegistrants.vue?vue&type=template&id=812ff946&scoped=true&"
import script from "./communityRegistrants.vue?vue&type=script&lang=js&"
export * from "./communityRegistrants.vue?vue&type=script&lang=js&"
import style0 from "./communityRegistrants.vue?vue&type=style&index=0&id=812ff946&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812ff946",
  null
  
)

export default component.exports